import pic1 from './pic1.png';
import pic2 from './pic2.png';
import pic3 from './pic3.png';
import pic4 from './pic4.png';
import pic5 from './pic5.png';

export default [
    pic1,
    pic2,
    pic3,
    pic4,
    pic5
];
